/* global DetectUserAgent */
import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player/lazy";

import { appRoutes } from "routes";
import { getImageUrl } from "utils/imageHandlerUtils";
import { handlerSelectItemEvent } from "tracking/google/analytics";
import StarringYouClipPresenter from "presenters/StarringYouClipPresenter";
import ResponsiveImage from "components/ResponsiveImage";
import Placeholder from "components/Placeholder";
import { useTemplateGroupTracking, useCategory, useHomePage } from "hooks";

import useStyles from "./useStyles";

const StarringYouClip = ({
  showVideo = true,
  item,
  loading = false,
  playing = false,
  isStatic = false,
  isActive = false,
  onClick,
  hasModulePosition,
}) => {
  const classes = useStyles();
  const clipRef = useRef(null);
  const { trackClick } = useTemplateGroupTracking(item);
  const { category } = useCategory();
  const { homePage } = useHomePage();
  const isFbInAppBrowser = DetectUserAgent.isFBInAppBrowser();

  const handleClick = () => {
    trackClick();

    if (onClick) onClick(item);

    if (!hasModulePosition) handlerSelectItemEvent(item, category, homePage);
  };

  if (loading)
    return (
      <div data-testid="starringyouclip-loading" className={classes.clipSkeleton}>
        <Placeholder variant="rect" animation="wave" ratio="16/9" />
      </div>
    );
  return (
    <Link
      onClick={handleClick}
      className={classes.root}
      to={appRoutes.templateGroupPath(StarringYouClipPresenter.id(item))}
      component={NavLink}
    >
      <div role="presentation" ref={clipRef} style={{ position: "relative" }}>
        <div className={classes.playerWrapper}>
          {showVideo === true && (
            <ReactPlayer
              height="100%"
              width="100%"
              className={classes.player}
              playing={playing}
              loop
              muted
              playsinline
              url={[{ src: StarringYouClipPresenter.animatedThumb(item), type: "video/mp4" }]}
              config={{
                attributes: {
                  poster: isActive && isFbInAppBrowser && getImageUrl(StarringYouClipPresenter.thumb(item), {}),
                },
              }}
            />
          )}
          {!isActive && (
            <ResponsiveImage
              alt={StarringYouClipPresenter.name(item)}
              src={StarringYouClipPresenter.thumb(item)}
              className={classes.poster}
              width={600}
              widthMobile={226}
            />
          )}
        </div>
        <div className={classes.overlay} />
        {item.titleImage && (
          <ResponsiveImage
            src={item.titleImage}
            alt={`${StarringYouClipPresenter.name(item)} Logo`}
            className={classes.imageName}
            width={442}
            widthMobile={170}
          />
        )}
        <span className={isStatic ? `${classes.duration} static` : classes.duration}>
          {StarringYouClipPresenter.duration(item)}
        </span>
      </div>
    </Link>
  );
};

StarringYouClip.propTypes = {
  showVideo: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    titleImage: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    attributes: PropTypes.shape({}),
  }),
  playing: PropTypes.bool,
  loading: PropTypes.bool,
  isStatic: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  hasModulePosition: PropTypes.bool,
};

export default StarringYouClip;
